export default __webpack_public_path__ + "static/media/rockett.a5d74125.png";